import { formatMoney } from "../../features/utils/formatMoney";

export function payoutTableData(order) {
  const name = [order?.account?.firstName, order?.account?.lastName]
    .filter((item) => item)
    .join(" ");

  return [
    {
      elements: [
        {
          type: "title",
          value: "User",
        },
        {
          type: "text",
          value: name,
        },
      ],
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Bank Account",
        },
        {
          type: "text",
          value: order?.bankAccount,
        },
      ],
      width: "md:w-[25%]",
    },

    {
      elements: [
        {
          type: "title",
          value: "Amount",
        },
        {
          type: "text",
          value: formatMoney(order?.amount),
        },
      ],
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Status",
        },
        {
          type: "status",
          value: order?.status,
        },
      ],
      width: "md:w-[15%]",
    },
  ];
}
